import AgeRestrictionModal from '@common/components/ageRestrictionModal/AgeRestrictionModal'
// import { ScrollToTop } from '@common/components/scrollToTop'
import { isDev } from '@common/consts/isDev'
import useNotificationObserver from '@common/hooks/useNotificationObserver'
import { useScrollToAnchor } from '@common/hooks/useScrollToAnchor'
import { StoreProvider } from '@common/providers/storeProvider'
import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import { NotificationListComponent } from '@vista-digital/occ-ui'
import { ErrorBoundary } from '@vista-digital/react-tools'
import type { ErrorInfo, FunctionComponent } from 'react'
import { memo, Suspense } from 'react'
import { Outlet } from 'react-router-v8'
import { LoadingProvider } from '@/common/providers/loadingProvider'
import { EmbedHeader } from '@/content/sections/header/EmbedHeader'
import { mobileEmbedService } from '@/content/services/mobileEmbed/mobileEmbed.service'
import { CaptureMapfreToken } from '../content/components/mapfre/CaptureMapfreToken'
import Popup from '../content/components/popup/Popup'
import { RootLevelErrorBoundary } from '../content/components/rootLevelErrorBoundary/RootLevelErrorBoundary'
import { Footer } from '../content/sections/footer'
import { Header } from '../content/sections/header/Header'

export interface LayoutOverrideProps {
    rootLevelErrorBoundaryOverride?: FunctionComponent
}

export const Layout: FunctionComponent<LayoutOverrideProps> = memo(props => {
    const isMobileApp = mobileEmbedService.isMobileApp()
    const rootLevelErrorBoundaryOverride = props?.rootLevelErrorBoundaryOverride
    const logRootLevelError = (error: Error, info: ErrorInfo) => {
        const loggerRoot = getLogger(['RootLevelErrorBoundary', error.name]).value
        loggerRoot.error(error.message, { stack: error.stack, componentStack: info.componentStack })
        if (isDev) {
            // eslint-disable-next-line no-console -- dev mode
            console.error(error, info)
        }
        if (isMobileApp) {
            mobileEmbedService.onError(error.message)
        }
    }

    useScrollToAnchor()
    useNotificationObserver()

    const ErrorBoundaryElement = rootLevelErrorBoundaryOverride
        ? rootLevelErrorBoundaryOverride
        : () => <RootLevelErrorBoundary />

    return (
        <ErrorBoundary
            fallback={
                <Suspense>
                    <ErrorBoundaryElement />
                </Suspense>
            }
            onError={logRootLevelError}
        >
            <LoadingProvider>
                <CaptureMapfreToken />

                <StoreProvider>
                    {!isMobileApp && <Header />}
                    {isMobileApp && <EmbedHeader />}
                    {/* <ScrollToTop /> */}
                    <div className="page-wrapper">
                        <Outlet />
                    </div>
                </StoreProvider>

                <AgeRestrictionModal />
                <NotificationListComponent />
                {!isMobileApp && <Footer />}
                <Popup />
            </LoadingProvider>
        </ErrorBoundary>
    )
})
